import type { FaireProductEntity } from "../../entity_types/product";

export const p_gnpue8sww9: FaireProductEntity = {
  token: "p_gnpue8sww9",
  type: "product",
  name: "Satellite Wafers 240 CT",
  brandToken: "b_ktcqb4hfg7",
  brandName: "L&F Universal Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/c763a2bc83958d228847d32ec23f073d8f4929378a5ae8e58de86ceb64451d61.jpeg",
  galleryImageUrls: [],
  priceDollars: 36.03,
  description:
    "Satellite wafers; nostalgic candy UFOs ideal for bulk novelty assortments.",
  tags: [],
  msrpDollars: 72.06,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:35.335Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
